import { render } from "./StudioView.vue?vue&type=template&id=36b055f8&scoped=true"
const script = {}

import "./StudioView.vue?vue&type=style&index=0&id=36b055f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b055f8"]])

export default __exports__